import { render, staticRenderFns } from "./dashboardParalex.vue?vue&type=template&id=31c77f64&"
import script from "./dashboardParalex.vue?vue&type=script&lang=js&"
export * from "./dashboardParalex.vue?vue&type=script&lang=js&"
import style0 from "./dashboardParalex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dashboardParalex.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VParallax } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VParallax,
})
